import { debounce } from 'lodash'
import { Controller } from 'stimulus'
import { BREAKPOINTS } from '../../_js/base/consts'

export default class PageNav extends Controller {
  isDesktop = true

  connect() {
    this.navHide = document.querySelector('.navHide')

    if (PageNav.isIOS()) {
      window.addEventListener(
        'scroll',
        debounce(() => {
          this.scrollEventHandler()
        }, 20),
        { passive: true }
      )
    } else {
      window.addEventListener('scroll', this.scrollEventHandler.bind(this), { passive: true })
    }

    this.scrollEventHandler()
  }

  scrollEventHandler() {
    this.isDesktop = window.innerWidth >= BREAKPOINTS.VIEWPORT_L
    const elementTop = this.element.getBoundingClientRect().top
    const navHideTop = this.navHide.getBoundingClientRect().top

    if (this.isDesktop) {
      this.element.classList.toggle('is-stuck', elementTop <= 0)
    } else {
      this.element.classList.toggle('is-stuck', elementTop <= 64)
    }

    this.element.classList.toggle('is-visible', navHideTop > 0)
  }

  static isIOS() {
    const platform = window.navigator?.userAgentData?.platform || window.navigator.platform
    const iosPlatforms = ['iPhone', 'iPad', 'iPod']

    if (iosPlatforms.indexOf(platform) !== -1) {
      return true
    }

    return false
  }
}
